import { type ReactNode } from 'react';

import { cn } from '@/_helpers/cn';

export const Badge = ({ children, color }: { children: ReactNode; color: 'pink' | 'green' | 'red' | 'orange' }) => {
  const variant = {
    pink: 'bg-accent-pinkLight text-accent-pink',
    green: 'bg-labels-greenBackground text-labels-greenText',
    red: 'bg-labels-redBackground text-labels-redText',
    orange: 'bg-labels-orangeBackground text-labels-orangeText',
  };
  return (
    <span className={cn('rounded-full px-2 py-1 text-xs font-medium leading-none text-white', variant[color])}>
      {children}
    </span>
  );
};
